import { useQueryClient } from '@tanstack/react-query';
import useMutationApi from 'src/api/useMutationApi';
import { Contact } from './useContacts';

export interface UpdateContactData {
  name?: string;
  email?: string;
  phone?: string;
  title?: string;
  isPrimary?: boolean;
  metadata?: object | null;
}

export interface UpdateContactResponse {
  data: Contact;
}

export function useUpdateContact(contactId: string, onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutationApi<UpdateContactData, UpdateContactResponse>({
    endpoint: `contacts/${contactId}`,
    method: 'PUT',
    successMessage: 'Contact updated successfully',
    errorMessage: 'Failed to update contact',
    options: {
      // NOTE: params _data/_variables/_context currently unused (kept via '_' prefix) — revisit and delete if not needed
      onSuccess: (_data, _variables, _context) => {
        // Invalidate contacts queries to refresh the data
        queryClient.invalidateQueries({
          queryKey: ['contacts'],
        });
        onSuccess?.();
      },
    },
  });
}

export default useUpdateContact;
